import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

export const CATEGORY_COLOR_VARIANTS = [
  LabelVariant.CYAN,
  LabelVariant.PURPLE,
  LabelVariant.GREEN,
  LabelVariant.ORANGE,
  LabelVariant.BLUE,
  LabelVariant.MAGENTA,
  LabelVariant.LIME,
  LabelVariant.BLUE_GRAY,
];
